import { createContext, getWithContextHOC } from '@futrli/shared-services';

export interface IDataGridContext {
  hasScrolled: boolean;
  tableRef: React.RefObject<HTMLDivElement>|undefined;
}

export type DataGridContextContextKeys = keyof IDataGridContext;

const DEFAULT_OPTIONS: DataGridContextContextKeys[] = [
  'hasScrolled',
  'tableRef'
];

/**
 * Sales context initilised to be shared.
 *
 * NOTE: The context is comprise of all properties we want to share between the parent
 * and lower level nodes and the nodes between them do not need to know about these properties.
 */
export const DataGridContext = createContext<Partial<IDataGridContext>>({
  hasScrolled: false,
  tableRef: undefined
});

/**
 * Injects the context to the component passed as param.
 * @name withDataGridContext
 * @function
 * @param {React.ComponentType<RC & CP>} Component - Component to wrap with the consumer.
 * @param {Array<keyof C>} options - Context props to inject into the component.
 * @template {RC} - React component props without context props.
 * @template {CP} - Context props of the component.
 *
 * @returns {React.ComponentType<RC>} - Wrapped component.
 */
export const withDataGridContext = getWithContextHOC(DataGridContext, DEFAULT_OPTIONS);
